/**
 * String functions for text manipulation
 */

/**
 * Convert string to title case
 * @param {string} str - The string to convert
 * @returns {string} - The title-cased string
 */
export const toTitleCase = (str) => {
  if (!str) return '';
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

/**
 * Trim name to maximum of three words
 * @param {string} name - The name to trim
 * @returns {string} - The trimmed name
 */
export const trimNameToThreeWords = (name) => {
  if (!name) return '';
  const words = name.split(' ').filter((word) => word !== '');
  return words.length > 3 ? words.slice(0, 3).join(' ') : name;
};
